module.exports = __webpack_public_path__ + "img/grua.1cdcab75.png";